import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import {isLoggedIn} from '@/helpers/auth';
import {publicRoutes} from '@/router/routes/public';
import {privateRoutes} from '@/router/routes/private';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [...publicRoutes, ...privateRoutes],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {x: 0, y: 0};
    }
  },
});

const handleRoute = (to, from, next) => {
  if (to.meta !== undefined) {
    if (!isLoggedIn() && to.meta.secure) {
      // Restricted path, and user not logged-in
      return next({path: '/login', replace: true});
    } else if (isLoggedIn() && store.state.isLimited && to.meta.admin) {
      return next({path: '/limited', replace: true});
    } else if (isLoggedIn() && !store.state.isAdmin && to.meta.admin){
      return next({path: '/unauthorized'});
    } else {
      // Path allowed
      return next();
    }
  } else {
    return next();
  }
};

router.beforeEach((to, from, next) => {
  if (store.getters.isApplicationStarted) {
    handleRoute(to, from, next);
  } else {
    // Application not started wait until « applicationStarted » is set to true.
    store.watch((state) => state.applicationStarted, (ready) => {
      if (ready) {
        handleRoute(to, from, next);
      }
    });
  }
});

export default router;
